import { useAuth0 } from "@auth0/auth0-react";
import { Check, InsertDriveFile } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import EmailIcon from "@mui/icons-material/Email";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import GasMeterOutlinedIcon from "@mui/icons-material/GasMeterOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import MonitorOutlinedIcon from "@mui/icons-material/MonitorOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import RecentActorsOutlinedIcon from "@mui/icons-material/RecentActorsOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import SyncIcon from "@mui/icons-material/Sync";
import UploadIcon from "@mui/icons-material/Upload";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Divider } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import { getAudience } from "auth-provider-wrapper";
import useAlert from "hooks/useAlert";
import { jwtDecode } from "jwt-decode";
import localforage from "localforage";
import _ from "lodash";
import moment from "moment";
import React, { useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setUsers } from "reducers/lookups";
import { localizationService } from "services/localization-service";
import { navigateTo } from "services/navigation-service";
import { apiService } from "services/rtkApi/apiService";
import { useGetUserLookupsQuery } from "services/rtkApi/endpoints/users";
import styled from "styled-components";
import { loadAccount } from "../actions/account";
import {
  getOrganizationUserId,
  hasAnyEventRole,
  hasAnyMonitoringRole,
  hasOrganizationUserId,
  roleMatch,
} from "../actions/auth";
import { loadUserOrg } from "../actions/organization";
import LynxLogoBW from "../images/Lynx-logomark-bw-rgb.svg";
import LynxLogo from "../images/Lynx-logomark-colour-rgb.svg";
import {
  default as colors,
  default as lynxColors,
} from "../modules/lynxColors";
import {
  getUserNoitifications,
  markNotificationAsRead,
  readAllNotifications,
} from "../services/notification-service";
import {
  eventSyncStore,
  offlineDataService,
} from "../services/offlineDataService";
import { urlService } from "../services/url-service";
import { mainTourSteps } from "../tours/main-tour";
import useWindowDimensions from "./../hooks/useWindowDimensions";
import { LocalStorageKeys, TourTypes, UserRoles } from "./../types/enums";
import { LynxDialog } from "./lynx-dialog";
import { LynxTour } from "./lynx-tour";
import "./navbar.css";
import { NotificationsMenu } from "./notifications-menu";
const NavbarTop = styled.div`
  background-color: ${(props) => (props.isMapModule ? "#0c0d0d" : "#ffffff")};
  position: fixed;
  left: 0;
  width: 100%;
  height: 50px;
  overflow: hidden;
  top: 0;
  border-bottom: 1px solid #ced4da;
`;

const MenuBottonSpan = styled.span`
  background-color: ${(props) => (props.isMapModule ? "#ffffff" : "#0c0d0d")};
  border-radius: 1px;
  display: block;
  left: 5px;
  width: 18px;
  height: 3px;
  margin-bottom: 3px;
  position: relative;
  transform-origin: 4px 0px;
  transition:
    transform 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
    background 0.5s cubic-bezier(0.77, 0.2, 0.05, 1),
    opacity 0.55s ease;
`;

const RightContainer = styled.div`
  position: relative;
  float: right;
  top: 14px;
  margin-right: 30px;
`;

const LeftContainer = styled.div`
  margin-left: 10px;
  position: relative;
  float: left;
  top: 14px;
  padding-right: 30px;
`;
const LogoDiv = styled.div`
  margin-left: 20px;
  position: relative;
  float: left;
  top: 14px;
  margin-right: -11rem;
  height: 50px;
`;

const MenuDiv = styled.div`
  position: relative;
  float: right;
  top: 14px;
  height: 50px;
  margin-right: 30px;
  color: #0c0d0d;
`;

const NavbarSelection = styled.div`


margin: 0px 10px 0px 10px
display: inline-block;
color: #0c0d0d;
font-size: 16px;
cursor: pointer;
`;
const LogoContainer = styled.img`
  height: 300px;
  margin-left: -6rem;
  margin-top: -8.75rem;
`;

function Navbar(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElAccount, setAnchorElAccount] = React.useState(null);
  const [anchorElHelp, setAnchorElHelp] = React.useState(null);

  const [initials, setInitials] = React.useState(null);
  const { isAuthenticated, isLoading, getAccessTokenSilently, logout } =
    useAuth0();
  const [isOfflineReady, setIsOfflineReady] = React.useState(true);
  const [unsyncedEventCount, setUnsyncedEventCount] = React.useState(0);
  const [showSyncDialog, setShowSyncDialog] = React.useState(false);
  const [showExpired, setShowExpired] = React.useState(false);
  const [showSupport, setShowSupport] = React.useState(false);
  const [showSyncLoading, setShowSyncLoading] = React.useState(false);
  const [notifications, setNotifications] = React.useState([]);
  const organization = useSelector((state) => state.organization);
  const [anchorElNotifications, setAnchorElNotifications] =
    React.useState(null);
  const openMenu = Boolean(anchorEl);
  const openAccount = Boolean(anchorElAccount);
  const openHelp = Boolean(anchorElHelp);
  const openNotificaions = Boolean(anchorElNotifications);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const isOffline = location.pathname.includes("/offline/");
  const account = useSelector((state) => state.account);
  const { width } = useWindowDimensions();
  const { showAlert } = useAlert();

  useEffect(() => {
    if (isAuthenticated) {
      const getUserMetadata = async () => {
        try {
          const accessToken = await getAccessTokenSilently({
            audience: getAudience(),
          });
          const decoded = jwtDecode(accessToken);
          const id = decoded.sub;
          localStorage.setItem(LocalStorageKeys.NameId, id);

          // Store Auth0 roles if present (will be merged with database roles later)
          const userRoles = decoded["https://lynx-esg.com/roles"];
          if (userRoles) {
            localStorage.setItem(LocalStorageKeys.UserRoles, userRoles);
          }
          // Note: Database roles will be loaded via loadAccount() after org selection
        } catch (e) {
          doLogout();
        }
      };
      getUserMetadata();
    }
  }, [isAuthenticated, isOffline]);

  useEffect(() => {
    if (
      isAuthenticated &&
      !isLoading &&
      !urlService.isPublicScreen(isAuthenticated) &&
      hasOrganizationUserId()
    ) {
      dispatch(loadAccount());
    }
  }, [dispatch, isAuthenticated, isLoading, hasOrganizationUserId()]);

  const { data: usersLookupData } = useGetUserLookupsQuery(
    {
      includePending: false,
      includeInternal: false,
    },
    {
      skip:
        !isAuthenticated ||
        account.isLoading ||
        account.isPortalUser ||
        urlService.isPublicScreen(isAuthenticated) ||
        !hasOrganizationUserId(),
    }
  );

  useEffect(() => {
    if (usersLookupData) {
      dispatch(setUsers(usersLookupData));
    }
  }, [usersLookupData, dispatch]);

  useEffect(() => {
    if (
      isAuthenticated &&
      !account.isLoading &&
      !account.isPortalUser &&
      !urlService.isPublicScreen(isAuthenticated) &&
      hasOrganizationUserId()
    ) {
      dispatch(loadUserOrg());
      loadNotifications();
      checkIfOfflineDataExists();
    }
  }, [dispatch, isAuthenticated, account.isLoading, hasOrganizationUserId]);

  useEffect(() => {
    setTimeout(function () {
      checkIfUnsyncedEvents();
    }, 3000);
  }, []);

  useEffect(() => {
    if (
      !_.isEmpty(organization) &&
      organization.licenseExpirationDateTimeUtc &&
      organization.licenseExpirationDateTimeUtc != null
    ) {
      const expirationDate = moment(organization.licenseExpirationDateTimeUtc);

      if (expirationDate < moment()) {
        setShowExpired(true);
      }
    }
  }, [organization]);

  const loadNotifications = () => {
    getUserNoitifications().then((res) => {
      setNotifications(res.data);
    });
  };

  const handleNotificationsClose = () => {
    setAnchorElNotifications(null);
  };

  const handleNotificationsClick = (e) => {
    setAnchorElNotifications(e.currentTarget);
  };

  const checkIfUnsyncedEvents = () => {
    localforage.getItem(eventSyncStore).then((res) => {
      if (res != null) {
        const totalEventsToSync = res.length;
        setUnsyncedEventCount(totalEventsToSync);
      }
    });
  };

  const checkIfOfflineDataExists = () => {
    let isReady = true;

    offlineDataService.checkIfOfflineIsReady().then((res) => {
      if (!res) {
        isReady = false;
      }
      setIsOfflineReady(isReady);
    });
  };

  const doLogout = () => {
    localStorage.removeItem(LocalStorageKeys.AccessToken);
    logout({ logoutParams: { returnTo: window.location.origin } });
  };
  const handleMenuClick = (event) => {
    setAnchorElAccount(null);
    if (openMenu) {
      handleClose();
    } else {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleAccountClick = (event) => {
    setAnchorEl(null);
    if (openAccount) {
      handleCloseAccount();
    } else {
      setAnchorElAccount(event.currentTarget);
    }
  };

  const handleHelpClick = (event) => {
    setAnchorElHelp(null);
    if (openHelp) {
      handleCloseHelp();
    } else {
      setAnchorElHelp(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleCloseAccount = () => {
    setAnchorElAccount(null);
  };

  const handleCloseHelp = () => {
    setAnchorElHelp(null);
  };
  const handlePrepOffline = () => {
    showAlert(
      "success",
      localizationService.getLocalizedString("screen.alerts.syncingData")
    );
    offlineDataService.prepareForOffline();
    setTimeout(function () {
      checkIfOfflineDataExists();
    }, 6000);
  };

  const handleSyncEvents = () => {
    setShowSyncDialog(true);
  };

  const handleConfirmSync = () => {
    setShowSyncLoading(true);
    offlineDataService.handleSyncEvents().then((res) => {
      if (res == true) {
        setTimeout(function () {
          checkIfUnsyncedEvents();
        }, 2000);
        setShowSyncDialog(false);
        setShowSyncLoading(false);
      }
    });
  };

  const handleMarkAsRead = (notification) => {
    handleNotificationClose();
    if (!notification.isRead) {
      markNotificationAsRead(notification.id, true).then((res) => {
        setNotifications(res.data);
      });
    }
  };

  const handleMarkAllAsRead = () => {
    readAllNotifications().then((res) => {
      setNotifications(res.data);
    });
  };

  const handleNotificationReadChange = (id, isRead) => {
    markNotificationAsRead(id, isRead).then((res) => {
      setNotifications(res.data);
    });
  };

  const handleNotificationClose = () => {
    setAnchorElNotifications(null);
  };

  const getTour = () => {
    return (
      <LynxTour
        title={localizationService.getLocalizedString(
          "screen.tours.main.title"
        )}
        description={localizationService.getLocalizedString(
          "screen.tours.main.description"
        )}
        steps={mainTourSteps}
        flagField={"initialTourCompletedDateTimeUtc"}
        tourType={TourTypes.Initial}
      />
    );
  };

  const getHelpMenu = () => {
    return (
      <>
        <MenuDiv className={`avatar-div  ${"mr-0"} help-menu`}>
          <Tooltip
            title={localizationService.getLocalizedString("screen.navbar.help")}
          >
            <IconButton
              onClick={handleHelpClick}
              aria-label="help"
              size="small"
            >
              <HelpOutlineIcon
                sx={{ fontSize: 30, color: lynxColors.harvestOrange }}
              />
            </IconButton>
          </Tooltip>
        </MenuDiv>
        <Menu
          className="nav-menu"
          anchorEl={anchorElHelp}
          open={openHelp}
          disableScrollLock={true}
          onClose={handleCloseHelp}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          <MenuItem
            onClick={() => {
              setShowSupport(true);
              handleCloseHelp();
            }}
          >
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText>
              <a>
                {localizationService.getLocalizedString(
                  "screen.navbar.contactSupport"
                )}
              </a>
            </ListItemText>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleCloseHelp();
            }}
          >
            <ListItemIcon>
              <MenuBookIcon />
            </ListItemIcon>
            <ListItemText>
              <a
                style={{ textDecoration: "none", color: "inherit" }}
                href="https://www.lynxglobalintelligence.com/knowledgehub"
                target="_blank"
                rel="noreferrer"
              >
                {localizationService.getLocalizedString(
                  "screen.navbar.knowledgeBase"
                )}
              </a>
            </ListItemText>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const handleSwitchOrg = (id) => {
    localStorage.setItem(LocalStorageKeys.OrganizationUserId, id);

    // Clear old roles - they'll be reloaded for the new org
    localStorage.removeItem(LocalStorageKeys.UserRoles);

    dispatch(loadUserOrg());
    dispatch(loadAccount()); // Reload account to get new org's roles
    dispatch(apiService.util.resetApiState());

    navigateTo(navigate, "/dashboard");

    handleCloseAccount();
  };

  const getUserAccountMenu = () => {
    return (
      <>
        <MenuDiv className="pointer avatar-div" onClick={handleAccountClick}>
          <Avatar
            src="/broken-image.jpg"
            sx={{ bgcolor: colors.harvestOrange }}
          >
            {initials}
          </Avatar>
        </MenuDiv>
        <>
          <MenuDiv className="avatar-div mr-3">
            <Tooltip
              title={localizationService.getLocalizedString(
                "screen.navbar.notifications"
              )}
            >
              <IconButton
                onClick={handleNotificationsClick}
                aria-label={localizationService.getLocalizedString(
                  "screen.navbar.notifications"
                )}
                size="small"
              >
                <Badge
                  badgeContent={notifications.filter((x) => !x.isRead).length}
                  color="primary"
                  className="pointer"
                >
                  <NotificationsIcon color="action" />
                </Badge>
              </IconButton>
            </Tooltip>
          </MenuDiv>
          <Menu
            id="basic-menu"
            anchorEl={anchorElNotifications}
            open={openNotificaions}
            onClose={handleNotificationsClose}
          >
            <NotificationsMenu
              notifications={notifications}
              handleMarkAsRead={handleMarkAsRead}
              handleMarkAllAsRead={handleMarkAllAsRead}
              handleNotificationClose={handleNotificationClose}
              handleNotificationReadChange={handleNotificationReadChange}
            />
          </Menu>
        </>
        <Menu
          className="nav-menu"
          anchorEl={anchorElAccount}
          open={openAccount}
          disableScrollLock={true}
          onClose={handleCloseAccount}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {roleMatch([UserRoles.SuperAdmin]) && !isOffline && (
            <MenuItem
              onClick={() => {
                navigate("/admin/customers");
                handleCloseAccount();
              }}
            >
              <ListItemText>
                {localizationService.getLocalizedString("screen.navbar.admin")}
              </ListItemText>
            </MenuItem>
          )}

          {!isOffline && (
            <MenuItem
              onClick={() => {
                navigate("/account");
                handleCloseAccount();
              }}
            >
              <ListItemText>
                {localizationService.getLocalizedString(
                  "screen.navbar.profile"
                )}
              </ListItemText>
            </MenuItem>
          )}
          <Divider />
          {props.account.organizationUsers.length > 1 && (
            <Box>
              {_.sortBy(props.account.organizationUsers, [
                "organizationName",
              ]).map((orgUser) => (
                <MenuItem
                  key={orgUser.id}
                  onClick={
                    _.toNumber(getOrganizationUserId()) == orgUser.id
                      ? null
                      : () => handleSwitchOrg(orgUser.id)
                  }
                >
                  <ListItemIcon>
                    {_.toNumber(getOrganizationUserId()) == orgUser.id && (
                      <Check />
                    )}
                  </ListItemIcon>
                  {orgUser.organizationName}
                </MenuItem>
              ))}
              <Divider />
            </Box>
          )}

          <MenuItem
            onClick={() => {
              doLogout();

              handleCloseAccount();
            }}
          >
            <ListItemText>
              {localizationService.getLocalizedString("screen.navbar.signOut")}
            </ListItemText>
          </MenuItem>
        </Menu>
      </>
    );
  };

  const getOfflineSyncOptions = () => {
    return (
      <>
        {" "}
        <MenuDiv className="avatar-div mr-1">
          <Tooltip
            title={
              isOffline
                ? localizationService.getLocalizedString(
                    "screen.errors.unableToSync"
                  )
                : isOfflineReady
                  ? localizationService.getLocalizedString(
                      "screen.navbar.readyForOffline"
                    )
                  : localizationService.getLocalizedString(
                      "screen.navbar.pressToSync"
                    )
            }
          >
            <IconButton
              onClick={() => {
                handlePrepOffline();
              }}
              aria-label="Not_synced"
              size="small"
              disabled={isOffline}
            >
              <SyncIcon
                sx={{
                  color: isOffline
                    ? "gray"
                    : isOfflineReady
                      ? lynxColors.success
                      : lynxColors.error,
                }}
              />
            </IconButton>
          </Tooltip>
        </MenuDiv>
        <MenuDiv className="avatar-div mr-1">
          <Tooltip
            title={localizationService.getLocalizedString(
              "screen.navbar.syncEvents"
            )}
          >
            <IconButton
              onClick={() => {
                handleSyncEvents();
              }}
              aria-label="Not_synced"
              size="small"
              disabled={isOffline}
            >
              <Badge badgeContent={unsyncedEventCount} color="primary">
                <UploadIcon color="primary" />
              </Badge>
            </IconButton>
          </Tooltip>
        </MenuDiv>
      </>
    );
  };

  const getMobileMenu = () => {
    return (
      <>
        <MenuDiv className="menu-button pointer" onClick={handleMenuClick}>
          <MenuBottonSpan></MenuBottonSpan>
          <MenuBottonSpan></MenuBottonSpan>
          <MenuBottonSpan></MenuBottonSpan>
          {localizationService.getLocalizedString("screen.navbar.menu")}
        </MenuDiv>
        <Menu
          className="nav-menu"
          anchorEl={anchorEl}
          open={openMenu}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {!isOffline && (
            <div>
              <MenuItem
                onClick={() => {
                  navigate("/dashboard");
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <MonitorOutlinedIcon />
                </ListItemIcon>
                <ListItemText>
                  {localizationService.getLocalizedString(
                    "dashboard.dashboard"
                  )}
                </ListItemText>
              </MenuItem>
              {roleMatch([UserRoles.Admin]) && (
                <MenuItem
                  onClick={() => {
                    navigate("/assets");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <HomeOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString("assets.assets")}
                  </ListItemText>
                </MenuItem>
              )}
              {hasAnyEventRole() && (
                <MenuItem
                  onClick={() => {
                    navigate("/events");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <EventOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString("events.events")}
                  </ListItemText>
                </MenuItem>
              )}
              {hasAnyEventRole() && organization.hasCommitments && (
                <MenuItem
                  onClick={() => {
                    navigate("/commitments");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <HandshakeOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString(
                      "commitments.commitments"
                    )}
                  </ListItemText>
                </MenuItem>
              )}
              {roleMatch([UserRoles.InspectionsUser]) && (
                <MenuItem
                  onClick={() => {
                    navigate("/inspections");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ContentPasteIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString(
                      "inspections.inspections"
                    )}
                  </ListItemText>
                </MenuItem>
              )}
              {roleMatch([UserRoles.IncidentsUser]) && (
                <MenuItem
                  onClick={() => {
                    navigate("/incidents");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <WarningAmberIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString(
                      "incidents.incidents"
                    )}
                  </ListItemText>
                </MenuItem>
              )}
              {(hasAnyEventRole() || roleMatch([UserRoles.IncidentsUser])) && (
                <MenuItem
                  onClick={() => {
                    navigate("/actions");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <PendingActionsIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString("actions.actions")}
                  </ListItemText>
                </MenuItem>
              )}
              {hasAnyEventRole() && organization.hasTraining && (
                <MenuItem
                  onClick={() => {
                    navigate("/training");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <SchoolOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString(
                      "training.training"
                    )}
                  </ListItemText>
                </MenuItem>
              )}
              {hasAnyMonitoringRole() && (
                <MenuItem
                  onClick={() => {
                    navigate("/monitoring");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <GasMeterOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString(
                      "monitoring.monitoring"
                    )}
                  </ListItemText>
                </MenuItem>
              )}
              {organization.hasPermitFeature && (
                <MenuItem
                  onClick={() => {
                    navigate("/permits");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ArticleIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString("permits.permits")}
                  </ListItemText>
                </MenuItem>
              )}
              {roleMatch([UserRoles.InspectionsUser]) && (
                <MenuItem
                  onClick={() => {
                    navigate("/equipment");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <ConstructionOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString(
                      "equipment.equipment"
                    )}
                  </ListItemText>
                </MenuItem>
              )}
              {hasAnyEventRole() && (
                <MenuItem
                  onClick={() => {
                    navigate("/contacts");
                    handleClose();
                  }}
                >
                  <ListItemIcon>
                    <RecentActorsOutlinedIcon />
                  </ListItemIcon>
                  <ListItemText>
                    {localizationService.getLocalizedString(
                      "contacts.contacts"
                    )}
                  </ListItemText>
                </MenuItem>
              )}

              <MenuItem
                onClick={() => {
                  navigate("/documents");
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <InsertDriveFile />
                </ListItemIcon>
                <ListItemText>
                  {localizationService.getLocalizedString(
                    "documents.documents"
                  )}
                </ListItemText>
              </MenuItem>

              <MenuItem
                onClick={() => {
                  navigate("/settings");
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <SettingsOutlinedIcon />
                </ListItemIcon>
                <ListItemText>
                  {localizationService.getLocalizedString("settings.settings")}
                </ListItemText>
              </MenuItem>
            </div>
          )}
          {isOffline && (
            <div>
              {roleMatch([UserRoles.InspectionsUser]) &&
                organization.isHealthAndSafety && (
                  <MenuItem
                    onClick={() => {
                      navigate("/offline/add-inspection");
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <ContentPasteIcon />
                    </ListItemIcon>
                    <ListItemText>
                      {localizationService.getLocalizedString(
                        "inspections.typos.addInspection"
                      )}
                    </ListItemText>
                  </MenuItem>
                )}
            </div>
          )}
        </Menu>
      </>
    );
  };

  const getLeftNavOptions = () => {
    return (
      <>
        <LeftContainer className="nav-options">
          {!isOffline && (
            <>
              <Link to="/dashboard" style={{ textDecoration: "none" }}>
                <NavbarSelection>
                  {localizationService.getLocalizedString(
                    "dashboard.dashboard"
                  )}
                </NavbarSelection>
              </Link>

              <Link to="/map" style={{ textDecoration: "none" }}>
                <NavbarSelection>
                  {localizationService.getLocalizedString("map.map")}
                </NavbarSelection>
              </Link>
              {(organization.enableAiEvents ||
                organization.enableAiMonitoringResults ||
                organization.enableAiIncidents ||
                organization.enableAiDocuments) &&
                roleMatch([UserRoles.Admin]) && (
                  <Link to="/ai" style={{ textDecoration: "none" }}>
                    <NavbarSelection>
                      {localizationService.getLocalizedString("ruby.ruby")}
                    </NavbarSelection>
                  </Link>
                )}
            </>
          )}
          {isOffline &&
            roleMatch([UserRoles.InspectionsUser]) &&
            organization.isHealthAndSafety && (
              <Link
                to="/offline/add-inspection"
                style={{ textDecoration: "none" }}
              >
                <NavbarSelection>
                  {localizationService.getLocalizedString(
                    "inspections.typos.addInspection"
                  )}
                </NavbarSelection>
              </Link>
            )}
        </LeftContainer>
        {isOffline && (
          <LeftContainer>
            <NavbarSelection style={{ cursor: "default", color: "red" }}>
              {localizationService.getLocalizedString(
                "screen.navbar.offlineMode"
              )}
            </NavbarSelection>
            {navigator.onLine && (
              <NavbarSelection
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/dashboard")}
              >
                Go Online
              </NavbarSelection>
            )}
          </LeftContainer>
        )}
      </>
    );
  };
  return isAuthenticated &&
    !account.isLoading &&
    ((account.hasAcceptedTermsOfUse &&
      account.isBillingInApp &&
      account.stripeId) ||
      (account.hasAcceptedTermsOfUse && !account.isBillingInApp) ||
      account.isInternal ||
      !account.isBillingInApp) ? (
    <NavbarTop className="d-print-none">
      <LynxDialog
        title={
          showSyncLoading
            ? localizationService.getLocalizedString(
                "screen.dialogs.eventsSyncing"
              )
            : localizationService.getLocalizedString(
                "screen.dialogs.syncEvents"
              )
        }
        description={
          showSyncLoading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            localizationService.getLocalizedString(
              "screen.dialogs.uploadMessage"
            )
          )
        }
        open={showSyncDialog}
        handleClose={
          showSyncLoading
            ? null
            : () => {
                setShowSyncDialog(false);
              }
        }
        handleConfirm={showSyncLoading ? null : handleConfirmSync}
      />

      {showSupport && (
        <LynxDialog
          title={localizationService.getLocalizedString(
            "screen.navbar.contactSupport"
          )}
          description={
            <div>
              {localizationService.getLocalizedString(
                "screen.dialogs.contactSupport1"
              )}
              &nbsp;
              <a
                href={`mailto:support@lynxglobalintelligence.com?subject=Lynx Support Request`}
              >
                support@lynxglobalintelligence.com
              </a>
              &nbsp;
              {localizationService.getLocalizedString(
                "screen.dialogs.contactSupport2"
              )}
            </div>
          }
          open={showSupport}
          handleClose={() => {
            setShowSupport(false);
          }}
          handleConfirm={() => setShowSupport(false)}
        />
      )}
      {showExpired && (
        <LynxDialog
          title={localizationService.getLocalizedString(
            "screen.dialogs.contactLynx"
          )}
          description={
            <div>
              {localizationService.getLocalizedString("screen.dialogs.expired")}
            </div>
          }
          open={showExpired}
          handleConfirm={() => {
            doLogout();
          }}
        />
      )}

      <LogoDiv>
        <LogoContainer
          src={props.isMapModule ? LynxLogoBW : LynxLogo}
        ></LogoContainer>
      </LogoDiv>
      {!account.isPortalUser && (
        <>
          {getMobileMenu()}
          {!isOffline && getUserAccountMenu()}
          {!isOffline && getHelpMenu()}
          {getOfflineSyncOptions()}
          {getLeftNavOptions()}
          {width > 900 &&
            !isOffline &&
            account.hasAcceptedTermsOfUse &&
            window.location.href.includes("/dashboard") &&
            getTour()}
        </>
      )}
    </NavbarTop>
  ) : (
    <NavbarTop>
      <LogoDiv>
        <LogoContainer src={LynxLogo}></LogoContainer>
      </LogoDiv>
      <LeftContainer></LeftContainer>
      {isAuthenticated ? (
        <RightContainer>
          <NavbarSelection onClick={doLogout}>
            {localizationService.getLocalizedString("screen.navbar.signOut")}
          </NavbarSelection>
        </RightContainer>
      ) : (
        <>
          {!isOffline && (
            <RightContainer>
              <Link to="/authorize" style={{ textDecoration: "none" }}>
                <NavbarSelection>
                  {localizationService.getLocalizedString(
                    "screen.navbar.signIn"
                  )}
                </NavbarSelection>
              </Link>
            </RightContainer>
          )}
        </>
      )}
      {isOffline && (
        <>
          {getMobileMenu()}
          {getLeftNavOptions()}
          {getOfflineSyncOptions()}
        </>
      )}
    </NavbarTop>
  );
}

const mapDispatchToProps = (dispatch) => ({});

const mapStateToProps = (state) => ({
  auth: state.auth,
  router: state.router,
  account: state.account,
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
